import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';

// Assets
import {ReactComponent as ExportIcon} from 'assets/img/export.svg'
import CustomButton from "../CustomButton";
import Popup from "./Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {WMSContext} from "../../views/wms/context/WMSContext";
import {BarCodeScannerContext} from "../../contexts/barCodeScannerContext";
import {launchOmniScan} from "../../api/wms/omiScan";
import {sortingMassTransfer} from "../../api/wms/wmsContainers/wmsContainers";
import {ReactComponent as EndMissionIcon} from "assets/img/wms/end_mission.svg";
import {ReactComponent as ErrorIcon} from "assets/img/picto-error-404.svg"
import {Grid} from "@mui/material";


FullTransfer.propTypes = {
    handleIsValid: PropTypes.func.isRequired,
    currentContainer: PropTypes.object.isRequired,
    inSorting: PropTypes.bool.isRequired,
    toContainers: PropTypes.array.isRequired,
    customMargin: PropTypes.string
};

function FullTransfer({handleIsValid, currentContainer, shipments = [], inSorting, toContainers, customMargin = null}) {
    const {currentInventory} = useContext(WMSContext)
    const {scannedString} = useContext(BarCodeScannerContext)
    const [openTransferErrorModal, setOpenTransferErrorModal] = useState(false)
    const [errors, setErrors] = useState()

    const [openFullTransferModal, setOpenFullTransferModal] = useState(false)

    const handleCloseFullTransferModal = (isTransferValid = false) => {
        setOpenFullTransferModal(false)
        if (isTransferValid) {
            handleIsValid(isTransferValid)
        }
    }

    const handleCloseTransferErrorModal = () => {
        setOpenTransferErrorModal(false)
        handleIsValid(true)
    }

    const getFormattedKey = (key) => {
        switch (key) {
            case "not-found":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.notFoundKey"}/>
            case "wrongInventory":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.wrongInventoryKey"}/>
            case "wrongType":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.wrongTypeKey"}/>
            default:
                return <FormattedMessage id={"list.error"}/>
        }
    }

    const getErrorModalSubtitle = () => {
        const errorKeys = Object.keys(errors)

        return (
            <>
                {errorKeys.map(key => {
                    return <Grid key={key} container direction={"column"}>
                        {getFormattedKey(key)}
                        {errors[key].map(shipment => {
                            return <span key={shipment}>{shipment}</span>
                        })}
                    </Grid>
                })}
            </>
        )
    }
    
    useEffect(() => {
        if (openFullTransferModal && 0 < scannedString.length && currentInventory && currentContainer) {
            launchOmniScan(scannedString, currentInventory.id, {container: toContainers}).then((response) => {
                if (1 === response.length) {
                    sortingMassTransfer(currentContainer.codebar, response[0].codebar, currentInventory.id, shipments).then(r => {
                        if (0 < Object.keys(r).length) {
                            setErrors(r)
                            handleCloseFullTransferModal(false)
                            setOpenTransferErrorModal(true)
                        } else {
                            handleCloseFullTransferModal(true)
                        }

                    })
                }
            })
        }
    }, [scannedString]);
    return (
        <>
            {openFullTransferModal && (
                <Popup
                    open={openFullTransferModal}
                    onClose={handleCloseFullTransferModal}
                    title={<FormattedMessage id={"wms.sorting.fullTransferModal.title"}/>}
                    subtitle={<FormattedMessage id={"wms.sorting.fullTransferModal.subtitle"}/>}
                    icon={<EndMissionIcon/>}
                    isMobile
                />
            )}

            {openTransferErrorModal && (
                <Popup
                    open={openTransferErrorModal}
                    onClose={handleCloseTransferErrorModal}
                    title={<FormattedMessage id={"wms.sorting.TransferErrorModal.title"}/>}
                    subtitle={getErrorModalSubtitle()}
                    icon={<ErrorIcon/>}
                    isMobile
                />
            )}
            <CustomButton
                onClick={() => setOpenFullTransferModal(true)}
                style={{
                    marginLeft: customMargin ?? '8px',
                    cursor: 'pointer'
                }}
                color={"blue"}
                fullWidth={inSorting}
            >
                {/* Base ExportIcon is facing upward */}
                <div style={{transform: "rotate(90deg"}}>
                    <ExportIcon />
                </div>
            </CustomButton>
        </>
    );
}

export default FullTransfer;
